import {
  getFirestore,
  where,
  query,
  collection,
  getDocs,
  updateDoc,
  doc,
  getDoc,
  serverTimestamp,
  setDoc,
  onSnapshot,
  deleteDoc,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { TYPES } from "./group.type";
import { REF } from "../ref";
import { app } from "../../config/config";

const firestore = getFirestore(app);
const auth = getAuth(app);

// ------------ get all group services ----------- //
let groupSub = [];
export const snapGroup =
  ({ branch }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.GROUP);
    const c0 = where("branch", "==", branch);
    const qRef = query(cRef, c0);
    const unsub = onSnapshot(qRef, (snapshot) => {
      if (snapshot) {
        const data = snapshot.docs.map((doc) => doc.data());
        console.log("trigger");
        selectGroupServiceSuccess(dispatch, data);
        if (callback) {
          callback();
        }
      }
    });

    groupSub.push(unsub);
  };

export const unSnapGroup = () => (dispatch) => {
  groupSub.forEach((subscriber) => {
    subscriber();
  });

  groupSub.length = 0;
};

// ------------ dispatch ----------- //
const selectGroupServiceSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SELECT_GROUP_SERVICE_SUCCESS,
    payload: data,
  });
};

// ------------ add Group Service ----------- //
export const addGroup =
  ({ group, branch }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.GROUP);
    const uRef = collection(firestore, REF.OWNER);
    const userId = auth?.currentUser?.uid;
    const d0Ref = doc(uRef, userId);

    getDoc(d0Ref).then((snapshot) => {
      if (snapshot) {
        let data = snapshot.data();
        data = data === undefined ? false : true;

        if (data) {
          // Add a new Group Data
          const id = doc(cRef).id;
          const dRef = doc(cRef, id);
          const groupData = {
            id,
            name: group,
            branch,
            createAt: serverTimestamp(),
          };

          setDoc(dRef, groupData, { merge: true })
            .then(() => {
              if (callback) {
                callback({
                  status: 200,
                });
              }
            })
            .catch((err) => {
              if (callback) {
                callback({
                  status: 500,
                  data: err?.message || "Please try again!",
                });
              }
            });
        } else {
          callback({
            status: 500,
            data: "You're not a owner",
          });
        }
      }
    });
  };

export const updateGroup =
  ({ update, group }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.GROUP);
    const uRef = collection(firestore, REF.OWNER);
    const userId = auth?.currentUser?.uid;
    const d0Ref = doc(uRef, userId);

    getDoc(d0Ref).then((snapshot) => {
      if (snapshot) {
        let data = snapshot.data();
        data = data === undefined ? false : true;

        if (data) {
          // Add a new Group Data
          const id = update?.id;
          const dRef = doc(cRef, id);
          const updated = {
            ...update,
            name: group,
            updateAt: serverTimestamp(),
          };

          updateDoc(dRef, updated)
            .then(() => {
              if (callback) {
                callback({
                  status: 200,
                });
              }
            })
            .catch((err) => {
              if (callback) {
                callback({
                  status: 500,
                  data: err?.message || "Please try again!",
                });
              }
            });
        } else {
          callback({
            status: 500,
            data: "You're not a owner",
          });
        }
      }
    });
  };

// -------------- delete the group ---------- //
export const deleteTheGroup =
  ({ id }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.GROUP);
    const dRef = doc(cRef, id);
    deleteDoc(dRef)
      .then(() => {
        if (callback) {
          callback({
            status: 200,
          });
        }
      })
      .catch((err) => {
        if (callback) {
          callback({
            status: 500,
            data: err?.message || "Please try again!",
          });
        }
      });
  };
